import { observable } from "mobx";
import SourceType from "./sourceType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class PaymentTemplateSimpleListResponse {
  /**
   * Payment template ID.
   */
  id!: string;

  /**
   * Payment template code.
   */
  @observable
  name!: string;

  /**
   * Flag indicating if payment template is deleted.
   */
  @observable
  isDeleted!: boolean;

  /**
   * Payment template code.
   */
  @observable
  code!: string;

  @observable
  sourceType!: SourceType;

  /**
   * Message template.
   */
  @observable
  messageTemplate!: string;
}
